function getOptions() {
  return [
    '<input>',
    'applyClass',
    'autoApply',
    'autoUpdateInput',
    'alwaysShowCalendars',
    'buttonClasses',
    'cancelClass',
    'dateLimit',
    'drops',
    'endDate',
    'isInvalidDate',
    'linkedCalendars',
    'locale',
    'maxDate',
    'minDate',
    'opens',
    'parentEl',
    'ranges',
    'showDropdowns',
    'showWeekNumbers',
    'singleDatePicker',
    'startDate',
    'template',
    'timePicker',
    'timePicker24Hour',
    'timePickerIncrement',
    'timePickerSeconds',
    'timeZone',
  ];
}

export default getOptions;
